import React from 'react';

import { useFeatureValue } from '@growthbook/growthbook-react';
import { z } from 'zod';

import InfoNote from '../utils/InfoNote';

type Props = {
  currentUser: { attributes: { email: string } };

  onApproveRequestedRefund: () => void;
};

const managersListSchema = z.object({
  managers: z.array(z.string()),
});

export default function ManagersSection(props: Props) {
  const managersListJSON = useFeatureValue(
    'order_refund_flow_managers_list',
    `{"managers":[]}`
  );

  const parseResult = managersListSchema.safeParse(managersListJSON);
  if (parseResult.success) {
    const managersList = parseResult.data.managers;
    const isManager = managersList.includes(props.currentUser.attributes.email);
    if (!isManager)
      return (
        <div className='data-box'>
          <h4>For Manager Use Only</h4>
          <InfoNote variant='info' faIcon='fa-info-circle'>
            <p>
              This section is now available only to managers who review and
              approve refund requests.
            </p>
            <span>
              If you need to request a refund, please use the{' '}
              <strong>Request Refund</strong> button in the{' '}
              <strong>Stripe Charges</strong> section.
            </span>
          </InfoNote>
        </div>
      );
  }

  return (
    <div className='data-box'>
      <h4>For Manager Use Only</h4>
      <button
        type='button'
        className='btn btn-primary'
        onClick={props.onApproveRequestedRefund}
      >
        Approve Requested Refund
      </button>
    </div>
  );
}
